module.exports = __webpack_public_path__ + "img/icon1.eaf18809.png";